















































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { Autorizacao, PendenciaSolicitacao } from '@/types/core'
import { timeoutDefault,
  groupCollectionByField,
  maskHour,
  timeout } from '@/utils/common'
import { TipoMensagemEnum,
  PendenciaMensagem,
  TipoDocumentoUpload,
  CancelarSolicitacaoParam,
  TipoOrigemEnum,
  SolicitacaoAcoesBackofficeEnum } from '@/types/_'

/* EventBus */
import EventBus from '@/plugins/EventBus'
import SituacaoEnum from '@/types/enum/SituacaoEnum'

@Component
export default class ComponentModalAtualizarProcesso extends Vue {
  $refs!: {
    backofficeCotacaoOperadoraSuprimentos: any
    protocoloOperadora: any
  }

  loadClose: boolean = false
  loadConfirmar: boolean = false
  loadRetornar: boolean = false

  tipoAutorizacaoAnexo: any = {
    pedidoMedico: true,
    laudo: true,
    cotacaoOpme: true,
    laudoAnestesista: false,
    anexoOperadora: false,
    resumo: true,
  }

  autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()

  get desabilitarCampo() {
    const { acoes, situacao } = this.getBackofficeGlobalStore.solicitacao
    if (!acoes.autorizacaoFazRetornoParaCotacao && situacao.key === 'EmCotacao') {
      return true
    }
    return false
  }

  get existsCotacaoChecked() {
    let existsChecked: boolean = false
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    grupoOpmeDaSolicitacao.forEach((c) => {
      c.opmes.forEach((o) => {
        if (o.fazCotacao) existsChecked = true
      })
    })
    return existsChecked
  }

  get showProtocoloOperadora() {
    const {
      situacao,
      autorizacaoDeveInformarProtocoloDaOperadora,
      cotacaoOperadorasExtraGrupo,
    } = this.getBackofficeGlobalStore.solicitacao
    if (situacao.key === SituacaoEnum.AnalisePreCotacao) {
      if (cotacaoOperadorasExtraGrupo && cotacaoOperadorasExtraGrupo.faturamentoDiretoComOperadora) {
        return true
      }
      if (this.existsCotacaoChecked) {
        if (this.$refs.protocoloOperadora) {
          const form = this.$refs.protocoloOperadora.$refs.protocoloOperadoraForm
          if (form) {
            form.reset()
            form.resetValidation()
          }
        }
        return false
      }

      return autorizacaoDeveInformarProtocoloDaOperadora
    }

    if (
      ['AnalisePreAutorizacao', 'EmCotacao', 'AnalisePosCotacao'].includes(situacao.key)
      && autorizacaoDeveInformarProtocoloDaOperadora
    ) {
      return true
    }

    return false
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingRetornar() {
    return this.loadRetornar
  }

  set loadingRetornar(val: boolean) {
    this.loadRetornar = val
  }

  get showModalAtualizarAutorizacao() {
    const show = this.getBackofficeGlobalStore.modal.atualizarAutorizacao
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalAtualizarAutorizacao(value) {
    this.getBackofficeGlobalStore.setModal({
      name: 'atualizarAutorizacao',
      value,
    })
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  /**
   * Pendência
   */

  modalConfirmarPendencia: boolean = false
  modalPendencia: boolean = false
  loadPendencia: boolean = false
  loadHistorico: boolean = false
  loadComentarios: boolean = false
  loadClosePedencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  loadUpload: boolean = false
  loadConfirmarPendencia: boolean = false
  loadCancelamento: boolean = false
  loadMensagem: boolean = false
  mensagem: string = ''
  respostaCotacaoError: string = ''
  inputFiles: any[] = []

  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao =
    new PendenciaSolicitacao.PendenciaSolicitacao()

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get loadingComentarios() {
    return this.loadComentarios
  }

  set loadingComentarios(value: boolean) {
    this.loadComentarios = value
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(val: boolean) {
    this.loadCloseConfirmarPendencia = val
  }

  get getDisplayPendencia() {
    return {
      nomePaciente: this.getBackofficeGlobalStore.solicitacao.pacienteNome,
      nomeMedico:
        this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome,
    }
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(val: boolean) {
    this.loadConfirmarPendencia = val
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get getRespostaCotacaoError() {
    return this.respostaCotacaoError
  }

  set getRespostaCotacaoError(value: string) {
    this.respostaCotacaoError = value
  }

  async confirmar() {
    this.loadingConfirmar = true
    this.getRespostaCotacaoError = ''

    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.loadingConfirmar = false
      this.showModalConfirmarPendencia = true
      return
    }

    if (this.temNaoInformadoComoFornecedor()) {
      this.showModalConfirmarFornecedor = true
      this.naoInformadoOuNaoHomologado = 'informado'
      this.loadingConfirmar = false
      return
    }

    if (this.temNaoHomologadoComoFornecedor()) {
      this.showModalConfirmarFornecedor = true
      this.naoInformadoOuNaoHomologado = 'homologado'
      this.loadingConfirmar = false
      return
    }

    const params = {
      acao: this.acoesByEtapa(),
      body: {
        protocoloOPME: this.getBackofficeGlobalStore.solicitacao.protocoloOPME,
        protocoloOperadora:
          this.getBackofficeGlobalStore.solicitacao.protocoloOperadora,
        cotacaoOperadorasExtraGrupo:
          this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo,
        operadoraSenhaProvisoria:
          this.getBackofficeGlobalStore.solicitacao.operadoraSenhaProvisoria,
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      },
    }

    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length > 0) {
      // @ts-ignore
      params.body.grupoOpmes = this.grupoOpmeDaSolicitacao()
      // Limpar todos os campos inválidos dos OPMES...
      // @ts-ignore
      params.body.grupoOpmes.forEach((grupoOpme: any) => {
        grupoOpme.opmes.forEach((opme: any) => {
          Object.entries(opme).forEach(([key, value]) => {
            // @ts-ignore
            if (['', null, undefined].includes(value)) {
              // eslint-disable-next-line
              delete opme[key]
            }
          })
        })
      })
    }

    const { formSuprimentos }: any = this.$refs.backofficeCotacaoOperadoraSuprimentos.$refs
    const allFormValidation: boolean[] = []
    if (formSuprimentos && formSuprimentos.length > 0) {
      formSuprimentos.forEach((form: any) => allFormValidation.push(form.validate()))
    }

    const anexoValidate = this.validarAnexoOperadora()
    const protocoloOperadora = this.validarProtocoloOperadora()

    if (
      anexoValidate
      && protocoloOperadora
      && allFormValidation.every((c: any) => c)
    ) {
      const response = await this.autorizacao.enviarGuias(params)
      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Processo atualizado com sucesso!',
          icon: 'done',
          color: '#2E7D32',
        })
        this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Ocorreu um erro ao atualizar a autorização.',
          icon: 'warning',
          color: '#C62828',
        })
      }
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Por favor, preencha todos os campos requeridos',
        icon: 'warning',
        color: '#C62828',
      })
    }

    this.loadingConfirmar = false
  }

  get respostaCotacaoNaoObrigatoria() {
    return (
      this.getBackofficeGlobalStore.template
      && this.getBackofficeGlobalStore.template.formulario
      && this.getBackofficeGlobalStore.template.formulario.suprimentosCotacao
      && this.getBackofficeGlobalStore.template.formulario.suprimentosCotacao.campos
      && this.getBackofficeGlobalStore.template.formulario.suprimentosCotacao.campos.naoExigeAnexoCotacao
    )
  }

  validarAnexoOperadora() {
    // Foi implementado essa regra pelo motivo da solicitacao
    // que tem integracao com o tasy nao retorna anexo de cotacao somente na situacao AnalisePosCotacao
    if (this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AnalisePosCotacao) {
      return true
    }

    if (this.respostaCotacaoNaoObrigatoria) return true

    const { backofficeCotacaoOperadoraSuprimentos } = this.$refs
    const { hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos } = this.getBackofficeGlobalStore.solicitacao
    const valid = backofficeCotacaoOperadoraSuprimentos
    && backofficeCotacaoOperadoraSuprimentos.getLaudos
    && backofficeCotacaoOperadoraSuprimentos.getLaudos.length > 0
    && !hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos
    if (!valid) {
      this.getRespostaCotacaoError = 'O campo resposta da cotação é obrigatório.'
    }
    return valid
  }

  validarProtocoloOperadora() {
    const { autorizacaoDeveInformarProtocoloDaOperadora } = this.getBackofficeGlobalStore.solicitacao
    if (autorizacaoDeveInformarProtocoloDaOperadora) {
      const { protocoloOperadora } = this.$refs
      return protocoloOperadora.$refs.protocoloOperadoraForm.validate()
    }
    return true
  }

  acoesByEtapa() {
    const { acoes } = this.getBackofficeGlobalStore.solicitacao
    if (acoes.autorizacaoFazAnalisePosCotacao) {
      return SolicitacaoAcoesBackofficeEnum.AutorizacaoFazAnalisePosCotacao
    }
    return SolicitacaoAcoesBackofficeEnum.AutorizacaoFazCotacao
  }

  grupoOpmeDaSolicitacao() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    return grupoOpmeDaSolicitacao.reduce((acc: any, obj: any) => {
      const opmes = obj.opmes.reduce((y: any, x: any) => {
        y.push({
          opmeId: x.opmeId,
          tipo: x.tipo,
          codigoHospital: x.codigoHospital,
          fazCotacao: !!x.fazCotacao,
          necessitaDeProfissionalAdicional: !!x.necessitaDeProfissionalAdicional,
          valorUnitario: x.valorUnitario,
        })
        return y
      }, [])

      acc.push({ id: obj.id, opmes })

      return acc
    }, [])
  }

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = false
  }

  async showComentario() {
    this.loadingComentarios = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentarios = false
  }

  async pendencia() {
    this.loadingPendencia = true
    await timeout(800)
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll-top-atualizar-processo')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  async closeModalPendencia() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeoutDefault()
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(solicitacaoId, mensagens)

    if (response.success) {
      this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Houve um erro ao enviar a pendência.',
        icon: 'warning',
        color: '#C62828',
      })
    }

    await timeoutDefault()
    this.loadingConfirmarPendencia = false
  }

  async inputFileAgendamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }
  /** Fim - Pendência */

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeout(400)
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      modal: 'atualizarAutorizacao',
      canceladoMotivo: {
        display: '',
        key: '',
      },
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
    })
    this.loadingCancelamento = false
  }

  async closeModalBtn() {
    this.loadingClose = true
    this.getRespostaCotacaoError = ''
    await this.closeModal()
    this.loadingClose = false
  }

  async closeModal() {
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.autorizacao.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.getBackofficeGlobalStore.closeModalAtualizarAutorizacao()
    this.getPendenciaStore.clearPendencia()
    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    this.getPendenciaStore.setModalConfirmar(false)
    this.$refs.backofficeCotacaoOperadoraSuprimentos.clearCodigoUnico()
    this.showModalConfirmarPendencia = false
    this.getRespostaCotacaoError = ''
    solicitacaoId = ''
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  /**
   * FORNECEDOR NÃO INFORMADO OU NÃO HOMOLOGADO
   */

  modalConfirmarFornecedor: boolean = false
  get showModalConfirmarFornecedor() {
    return this.modalConfirmarFornecedor
  }

  set showModalConfirmarFornecedor(value: boolean) {
    this.modalConfirmarFornecedor = value
  }

  loadEditFornecedores: boolean = false

  get loadingEditFornecedores() { return this.loadEditFornecedores }
  set loadingEditFornecedores(value: boolean) { this.loadEditFornecedores = value }

  async openModalEditarFornecedorOPME() {
    this.loadingEditFornecedores = true
    const request = await this.getBackofficeGlobalStore.getFornecedoresFromApi()
    if (request && request.length > 0) {
      this.getBackofficeGlobalStore.setModal({ name: 'modalEditarFornecedorOPME', value: true })
      this.showModalConfirmarFornecedor = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || `Ocorreu um erro ao buscar fornecedores... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingEditFornecedores = false
  }

  naoInformadoOuNaoHomologadoInput: string = 'informado'
  get naoInformadoOuNaoHomologado() { return this.naoInformadoOuNaoHomologadoInput }
  set naoInformadoOuNaoHomologado(value: string) { this.naoInformadoOuNaoHomologadoInput = value }

  temNaoInformadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoInformado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoInformado.push(false)
        if (!opme.fornecedor2) algumNaoInformado.push(false)
        if (!opme.fornecedor3) algumNaoInformado.push(false)

        // Caso não exista a flag de alertaFornecedorNaoInformado, utilizar o método antigo
        const invalido = (f: string) => {
          const e = f
          return opme[e] === undefined
            ? false
            : opme[e].nome.toUpperCase() === 'NÃO INFORMADO' || !!opme[e].alertaFornecedorNaoInformado
        }

        algumNaoInformado.push(invalido('fornecedor1'))
        algumNaoInformado.push(invalido('fornecedor2'))
        algumNaoInformado.push(invalido('fornecedor3'))
      })
    })
    return algumNaoInformado.some((e: boolean) => e)
  }

  temNaoHomologadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoHomologado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoHomologado.push(false)
        if (!opme.fornecedor2) algumNaoHomologado.push(false)
        if (!opme.fornecedor3) algumNaoHomologado.push(false)

        algumNaoHomologado.push(!!opme.fornecedor1 && !!opme.fornecedor1.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor2 && !!opme.fornecedor2.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor3 && !!opme.fornecedor3.alertaFornecedorNaoHomologado)
      })
    })
    return algumNaoHomologado.some((e: boolean) => e)
  }
}
